import { Controller } from "@hotwired/stimulus"
import { Select } from "mdb-ui-kit"
import { useIntersection } from "stimulus-use"

// MDB select component
// https://mdbootstrap.com/docs/standard/forms/select/
// When it is initially hidden or when turbo frame inserts it, we need to
// reinitialize. We are using `.update` since hidden components are already
// initialized. So for all data-mdb-select-init add this controller. For example:
//
//    <div data-mdb-select-init data-controller="mdb-select-appear">
export default class extends Controller {
  connect() {
    useIntersection(this)

    // Handle Turbo back button
    this.handleTurboRender = () => {
      this.reinitializeSelect()
    }
    document.addEventListener("turbo:render", this.handleTurboRender)
  }

  appear() {
    this.reinitializeSelect()
  }

  reinitializeSelect() {
    const instance = Select.getInstance(this.element)
    if (instance) {
      instance.dispose()
    }

    const wrapper = this.element.closest(".select-wrapper")
    if (wrapper && wrapper !== this.element) {
      wrapper.replaceWith(this.element)
    }

    Select.getOrCreateInstance(this.element)
  }
}
